import Vue from 'vue'
import Router from 'vue-router'
// import BaseContainer from './components/base/BaseContainer.vue'
// import Dashboard from './views/Dashboard.vue'

// import Login from './views/Login.vue'
// import ChangePassword from './views/ChangePassword.vue'
// import UserManagement from './views/UserManagement.vue'

// import Input from './views/Input.vue'
// import Create from './views/Create.vue'
// import Overview from './views/Overview.vue'
// import DataInput from './views/DataInput.vue'
// import IPRCurve from './views/IPRCurve.vue'
// import PumpSelection from './views/PumpSelection.vue'
// import EquipmentSelection from './views/EquipmentSelection.vue'
// import Trajectory from './views/Trajectory.vue'

Vue.use(Router)

const emptyComp = { component: { render: h => h('router-view') } }

const BaseContainer = resolve => require(['./components/base/BaseContainer.vue'], resolve)
const Dashboard = resolve => require(['./views/Dashboard.vue'], resolve)
const Login = resolve => require(['./views/Login.vue'], resolve)
const ChangePassword = resolve => require(['./views/ChangePassword.vue'], resolve)
const UserManagement = resolve => require(['./views/UserManagement.vue'], resolve)
const Input = resolve => require(['./views/Input.vue'], resolve)
const Create = resolve => require(['./views/Create.vue'], resolve)
const Overview = resolve => require(['./views/Overview.vue'], resolve)
const DataInput = resolve => require(['./views/DataInput.vue'], resolve)
const IPRCurve = resolve => require(['./views/IPRCurve.vue'], resolve)
const PumpSelection = resolve => require(['./views/PumpSelection.vue'], resolve)
const EquipmentSelection = resolve => require(['./views/EquipmentSelection.vue'], resolve)
const Trajectory = resolve => require(['./views/Trajectory.vue'], resolve)
const StringDiagram = resolve => require(['./views/StringDiagram.vue'], resolve)
export default new Router({
    mode: 'history',
    base: '/wespi/',
    routes: [
        {
            path: '/',
            name: 'home',
            component: BaseContainer,
            redirect: '/dashboard',
            children: [
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    meta: { appName: "Dashboard" },
                    component: Dashboard
                },
                {
                    path: '/create',
                    name: 'Create New Calculation',
                    component: Create
                },
                {
                    path: '/management',
                    name: 'Management',
                    redirect: '/management/change-password',
                    ...emptyComp,
                    children: [
                        {
                            path: '/management/change-password',
                            name: 'Change Password',
                            component: ChangePassword
                        },
                        {
                            path: '/management/user',
                            name: 'User Management',
                            component: UserManagement
                        }
                    ]
                },
                {
                    path: '/input',
                    name: 'Input',
                    component: Input,
                    // redirect: '/input/overview',
                    children: [
                        {
                            path: '/input/overview',
                            name: 'Overview',
                            component: Overview
                        },
                        {
                            path: '/input/data-input',
                            name: 'Data Input',
                            component: DataInput
                        },
                        {
                            path: '/input/ipr-curve',
                            name: 'IPR Curve',
                            component: IPRCurve
                        },
                        {
                            path: '/input/pump-selection',
                            name: 'Pump Selection',
                            component: PumpSelection
                        },
                        {
                            path: '/input/equipment-selection',
                            name: 'Equipment Selection',
                            component: EquipmentSelection
                        },
                        {
                            path: '/input/trajectory',
                            name: 'Trajectory',
                            component: Trajectory
                        },
                        {
                            path: '/input/string-diagram',
                            name: 'String Diagram',
                            component: StringDiagram
                        }
                        
                        
                    ]
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: Login // () => import(/* webpackChunkName: "about" */ './views/About.vue')
        }
    ]
})

//Sample lazy loading
// const HomePage = resolve => require(['./HomePage.vue'], resolve);

// const rounter = new VueRouter({
//   routes: [
//     {
//       path: '/',
//       name: 'HomePage',
//       component: HomePage
//     }
//   ]
// })